/**
 * Error codes for orders:
 * -1: Items have onhold or not found error, each item will have an error
 *     -1 item onhold, -2 item not found
 * -2: Failed to submit order on IQ with exception
 * -3: Order submitted, failed to get IQ response with purchase order number
 * -4: API failed with XML error details
 * -5: API failed with no error details but API error response
 * -6: Cannot parse XML into details with exception
 * -7: User settings are empty and cannot process PDF and email
 * -8: PDF generation error with exception
 * -9: PDF upload error
 * -10: Error uploading email request to be sent
 */
export enum AutoOrderOrderErrorEnum {
  ORDER_ITEM_ERROR = -1,
  ORDER_SUBMIT_EXCEPTION = -2,
  ORDER_SUBMIT_NO_RESPONSE = -3,
  API_XML_ERROR = -4,
  API_GENERIC_ERROR = -5,
  XML_PARSE_EXCEPTION = -6,
  USER_SETTINGS_EMPTY = -7,
  PDF_GENERATION_ERROR = -8,
  PDF_UPLOAD_ERROR = -9,
  EMAIL_UPLOAD_ERROR = -10,
}

export enum AutoOrderOrderErrorHumanReadableEnum {
  'Order Item Error' = -1,
  'Order Submit Exception' = -2,
  'Order Submit No Response' = -3,
  'API XML Error' = -4,
  'API Generic Error' = -5,
  'XML Parse Exception' = -6,
  'User Settings Empty' = -7,
  'PDF Generation Error' = -8,
  'PDF Upload Error' = -9,
  'Email Upload Error' = -10,
}

export enum AutoOrderOrderItemErrorEnum {
  notFound = -2,
  onHold = -1
}

export enum AutoOrderOrderItemErrorHumanReadableEnum {
  'Not Found' = -2,
  'On Hold' = -1
}
